import { FC, useEffect } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareCodeScanTracker } from './CareCodeScanTracker';

// Mounted once at the app shell. Reports a Care Code scan on the first render after the viewer
// session has been exchanged, which is the earliest point the app is running normally.
export const CareCodeScanTracking: FC = () => {
    const tracker = useInstance(CareCodeScanTracker);

    useEffect(() => {
        tracker.trackIfArrivedByCareCode();
    }, [tracker]);

    return null;
};
